import * as React from 'react';
import ResendEmailConfirmationForm from 'components/Registration/ResendEmailConfirmationForm';
import { Row, Col } from 'antd';
import CenteredPageContainer from 'components/Layout/CenteredPageContainer';

export interface Props {
  children?: React.ReactNode;
}

export interface State { }

export default class ResendEmailConfirmationPage extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {};
  }

  render() {
    return (
      <Row type="flex" align="middle" style={{ border: "solid lightgrey 2px", borderRadius: "15px", padding: "15px 20px 30px", marginTop: "5px" }}>
        <Col span={24}>
          <ResendEmailConfirmationForm />
        </Col>
      </Row>
    );
  }
}
